/**
 * 탈퇴가 끝났거나 진행 중인 계정은 백엔드가 모든 요청을 401/409로 막는다.
 * 브라우저에 남은 로그인 토큰은 최대 1시간 살아 있어 화면이 같은 요청을 계속 보낸다.
 * 그 응답을 한 번 보면 로그아웃한다. 본인 탈퇴 요청이 진행 중일 때는 탈퇴 화면이 직접 처리한다.
 */

export const ACCOUNT_DELETED_DETAILS = Object.freeze([
  '삭제된 계정이에요.',
  '계정 삭제가 진행 중이에요.',
]);

const ACCOUNT_DELETE_PATH = '/api/user/account';

export const isAccountDeletionDetail = (detail) => (
  typeof detail === 'string' && ACCOUNT_DELETED_DETAILS.includes(detail)
);

const requestUrl = (input) => {
  if (typeof input === 'string') return input;
  if (input && typeof input.url === 'string') return input.url;
  return String(input || '');
};

const requestMethod = (input, init) => String(
  init?.method || (input && typeof input === 'object' ? input.method : '') || 'GET',
).toUpperCase();

export const installAccountDeletionGuard = (onAccountDeleted, target = window) => {
  if (!target || typeof target.fetch !== 'function') return () => {};
  const originalFetch = target.fetch;
  let pendingOwnDeletion = 0;
  let fired = false;

  const guardedFetch = async (input, init) => {
    const url = requestUrl(input);
    const ownDeletion = url.split('?')[0].endsWith(ACCOUNT_DELETE_PATH)
      && requestMethod(input, init) === 'DELETE';
    if (ownDeletion) pendingOwnDeletion += 1;
    try {
      const response = await originalFetch.call(target, input, init);
      if (
        !fired
        && !ownDeletion
        && pendingOwnDeletion === 0
        && (response.status === 401 || response.status === 409)
        && url.includes('/api/')
      ) {
        response.clone().json().then((body) => {
          if (fired || pendingOwnDeletion > 0 || !isAccountDeletionDetail(body?.detail)) return;
          fired = true;
          onAccountDeleted();
        }).catch(() => {});
      }
      return response;
    } finally {
      if (ownDeletion) pendingOwnDeletion -= 1;
    }
  };

  target.fetch = guardedFetch;
  return () => {
    if (target.fetch === guardedFetch) target.fetch = originalFetch;
  };
};
